"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAQItemToJSON = exports.FAQItemFromJSONTyped = exports.FAQItemFromJSON = exports.instanceOfFAQItem = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the FAQItem interface.
 */
function instanceOfFAQItem(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFAQItem = instanceOfFAQItem;
function FAQItemFromJSON(json) {
    return FAQItemFromJSONTyped(json, false);
}
exports.FAQItemFromJSON = FAQItemFromJSON;
function FAQItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'question': !(0, runtime_1.exists)(json, 'question') ? undefined : json['question'],
        'answer': !(0, runtime_1.exists)(json, 'answer') ? undefined : json['answer'],
    };
}
exports.FAQItemFromJSONTyped = FAQItemFromJSONTyped;
function FAQItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'question': value.question,
        'answer': value.answer,
    };
}
exports.FAQItemToJSON = FAQItemToJSON;
